import React, { useEffect } from "react";
import { connect } from "react-redux";

import Routes from "./routes"
import { importAdminDataFromLocal, onReloadAdmin } from "./store/auth/actions";
import Loader from "./components/ui/overlay"
import Toast from "./components/ui/toast";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import MyLoader from "./components/ui/overlay";

function App(props) {
    // console.log(process.env);
    useEffect(() => {
        props.importAdminDataFromLocal();
    }, [])

    useEffect(() =>{
        if(props.auth.authDetails.token){
            props.onReloadAdmin();
        }
    },[])
    
    // The login route is "/" and only renders while there is no session.
    const isAuthScreen = !props.auth?.authDetails?.token;

    return (
        <>
            <div className="App">
                <Routes />
                <Toast />
                {/* Suppressed on the login screen: the sign-in button carries
                    its own spinner there, and a second indicator over a dimmed
                    page competed with it while washing out the form. Every
                    other screen still gets the overlay. */}
                {props.notification.loading && !isAuthScreen ? (
                    <MyLoader active={props.notification.loading} />
                ) : null}
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        notification: state.Notification,
        auth:state.Auth
    }
}

const mapDispatchToProps = { importAdminDataFromLocal, onReloadAdmin }

export default connect(mapStateToProps, mapDispatchToProps)(App);